<template>
    <div class="form-nested-accordion">
        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <div class="choose-radio-methods">
                    <label class="radio-option">
                        <input name="TipoDocumento"
                               value="0"
                               type="radio"
                               checked
                               v-model="formTipoPessoa.tipoPessoa" />
                        <span>Importar Meus documentos</span>
                    </label>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6">
                <div class="choose-radio-methods">
                    <label class="radio-option">
                        <input name="TipoDocumento"
                               value="1"
                               type="radio"
                               checked
                               v-model="formTipoPessoa.tipoPessoa" />
                        <span>Importar documentos de terceiros</span>
                    </label>
                </div>
            </div>
        </div>
        <Loader v-if="loadingDocuments" />
        <!-- Meus Documentos Aprovação -->
        <div class="row" v-if="!loadingDocuments">
            <div class="col-md-12">
                <div class="row">
                    <div class="alert alert-warning">
                        <span><strong>Para completar seu cadastro, faça o upload dos documentos faltantes.</strong></span>
                    </div>
                </div>
                <div class="row">
                    <dl>
                        <dt class="redLegend"></dt>
                        <dd>Documentos Rejeitados</dd>

                        <dt class="yellowLegend"></dt>
                        <dd>Documentos Em Análise</dd>

                        <dt class="greenLegend"></dt>
                        <dd>Documentos Aprovados</dd>
                    </dl>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <vue-good-table :columns="columns"
                                        :rows="registros"
                                        :sort-options="{enabled: false}"
                                        :row-style-class="rowStyleClassFn"
                                        styleClass="vgt-table">
                            <div slot="emptystate">Sem dados para exibição</div>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <!-- Enviar documentos pessoais -->
        <div class="row docs-pessoais" v-if="formTipoPessoa.tipoPessoa==0">
            <form @submit.prevent="EnviarPessoais" name="frm-docsPessoais">
                <div class="col-xs-12 col-sm-4">
                    <fieldset class="wrap-input">
                        <label for="docs-file-pessoal">Selecione um arquivo</label>
                        <div class="wrapper-file">
                            <label for="input-file" class="file-container">
                                <span class="file-name">somente arquivos em pdf</span>
                                <i class="fa fa-file-pdf-o" />
                            </label>
                            <input type="file"
                                   id="input-file"
                                   v-on:change.prevent="SelecionaArquivo"
                                   accept=".pdf" />
                            <div v-if="frmDocsPessoais.nomeArquivo"
                                 id="arquivoPessoal"
                                 style="
                position: absolute;
                top: 20px;
                right: 0px;
                left: 16px;
                background: #0083ca;
                padding: 12px;
                width: 94%;
                color: white;
                white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
                ">
                                <span @click="removeClass" style="color: white;" class="close">x</span>
                                <span>{{ frmDocsPessoais.nomeArquivo }}</span>
                            </div>
                            <label v-if="frmDocsPessoais.fileSize">{{ frmDocsPessoais.fileSize }}</label>
                        </div>
                        <span v-if="!isFilevalid.status && frmDocsPessoais.attemptSubmit"
                              class="invalid-feedback">{{ isFilevalid.message }}</span>
                    </fieldset>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <fieldset class="wrap-input">
                        <label for="docs-file-tipoPessoa">Tipo do documento</label>
                        <vue-select v-model="frmDocsPessoais.tipoDocumento"
                                    :options="frmDocsPessoais.tipoDocs"
                                    :select-on-tab="true"
                                    placeholder="Selecione um Tipo de Documento"
                                    required></vue-select>
                        <span v-if="!isTypeValid.status && frmDocsPessoais.attemptSubmit"
                              class="invalid-feedback">{{ isTypeValid.message }}</span>
                    </fieldset>
                </div>
                <div class="col-xs-2">
                    <div class="wrap-butons-line">
                        <button class="btn btn-primary" style="margin-top: 12px;">Enviar</button>
                    </div>
                </div>
            </form>
        </div>

        <!-- Enviar documentos de terceiros -->
        <div class="row docs-terceiros" v-if="formTipoPessoa.tipoPessoa==1">
            <form @submit.prevent="EnviarTerceiros" name="frm-docsTerceiros">
                <div class="col-xs-12">
                    <fieldset class="wrap-input">
                        <label for="docs-file-pessoal">Cliente</label>
                        <vue-select v-model="frmDocsTerceiros.idCliente"
                                    :options="frmDocsTerceiros.clientes"
                                    :select-on-tab="true"
                                    placeholder="Selecione o cliente"
                                    required></vue-select>
                        <span v-if="!isTerceiroValid.status && frmDocsTerceiros.attemptSubmit"
                              class="invalid-feedback">{{ isTerceiroValid.message }}</span>
                    </fieldset>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <fieldset class="wrap-input">
                        <label for="docs-file-pessoal">Selecione um arquivo</label>
                        <div class="wrapper-file">
                            <label for="input-file" class="file-container">
                                <span class="file-name">somente arquivos em pdf</span>
                                <i class="fa fa-file-pdf-o" />
                            </label>
                            <input type="file"
                                   id="input-file"
                                   v-on:change.prevent="SelecionaArquivo"
                                   accept=".pdf" />
                            <div v-if="frmDocsTerceiros.nomeArquivo"
                                 id="arquivoTerceiro"
                                 style="
                position: absolute;
                top: 20px;
                right: 0px;
                left: 16px;
                background: #0083ca;
                padding: 12px;
                max-width: 95%;
                color: white;
                white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                <span @click="removeClass" style="color: white;" class="close">x</span>
                                <span>{{ frmDocsTerceiros.nomeArquivo }}</span>
                            </div>
                            <label v-if="frmDocsTerceiros.fileSize">{{ frmDocsTerceiros.fileSize }}</label>
                        </div>
                        <span v-if="!isFilevalid.status && frmDocsTerceiros.attemptSubmit"
                              class="invalid-feedback">{{ isFilevalid.message }}</span>
                    </fieldset>
                </div>

                <div class="col-xs-12 col-sm-6">
                    <fieldset class="wrap-input">
                        <label for="docs-file-tipoPessoa">Tipo do documento</label>
                        <vue-select v-model="frmDocsTerceiros.tipoDocumento"
                                    :options="frmDocsTerceiros.tipoDocs"
                                    :select-on-tab="true"
                                    placeholder="Selecione um Tipo de Documento"
                                    required></vue-select>
                        <span v-if="!isTypeValid.status && frmDocsTerceiros.attemptSubmit"
                              class="invalid-feedback">{{ isTypeValid.message }}</span>
                    </fieldset>
                </div>
                <div class="col-xs-12">
                    <div class="wrap-butons-line">
                        <button class="btn btn-primary">Enviar</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="alert alert-info" role="alert">
                    <p>
                        <i class="fa fa-upload" /> Envie apenas arquivos com as extensões .PDF, com no máximo 2Mb
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<style type="text/css">
    .greenRow {
        background-color: #87db98;
    }

    .yellowRow {
        background-color: #f9f1cf;
    }

    .redRow {
        background-color: #e4b6ba;
    }

    dl dt {
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle;
    }

    dl dd {
        display: inline-block;
        margin: 0px 10px;
        padding-bottom: 0;
        vertical-align: middle;
    }

    dl dt.redLegend {
        background: #e4b6ba;
    }

    dl dt.yellowLegend {
        background: #f9f1cf;
    }

    dl dt.greenLegend {
        background: #87db98;
    }
</style>
<script>
    import "vue-good-table/dist/vue-good-table.css";

    import { VueGoodTable } from "vue-good-table";
    export default {
        name: 'SendDocuments',
        props: {
            msg:String,
            codRevenda:String
        },                  
        components: {
            VueGoodTable
        },
        data() {
            return {
                frmDocsPessoais: {
                    tipoPessoa: 0,
                    nomeArquivo: '',
                    documento: null,
                    attemptSubmit: false,
                    tipoDocumento: null,
                    tipoDocs: [],
                    fileSize: ''
                },
                frmDocsTerceiros: {
                    tipoPessoa: 1,
                    idCliente: null,
                    nomeArquivo: '',
                    documento: null,
                    attemptSubmit: false,
                    tipoDocumento: null,
                    tipoDocs: [],
                    clientes: [],
                    fileSize: ''
                },
                formTipoPessoa: {
                    tipoPessoa: 0
                },
                loadingDocuments: true,
                registros: [],
                columns: [
                    { label: "Código", field: "anexo_id" },
                    { label: "Documento", field: "dot_nome" },
                    { label: "Nome", field: "anexo_nome" },
                    { label: "Data", field: "anexo_data" },
                    { label: "Usuário", field: "anexo_usuario" },
                    { label: "Status", field: "anexo_status" },
                    { label: "Observação", field: "anexo_observacao" }
                ]
            }
        },
        mounted() {
            const self = this
            let tipoDocumento = {}
            self.getDados();
            $.ajax({
                url: this.$apiUrl + "UploadService.svc/listtipos",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                success: data => {
                    data.forEach((element, index) => {
                        tipoDocumento = {}
                        tipoDocumento.label = element.DotNomesite
                        tipoDocumento.nome = element.DotNome
                        tipoDocumento.dotcodigo = element.DotCodigo
                        self.frmDocsPessoais.tipoDocs.push(tipoDocumento)
                        self.frmDocsTerceiros.tipoDocs.push(tipoDocumento)
                    })
                }
            })

            let cliente = {}

            $.ajax({
                url: this.$apiUrl + "UploadService.svc/listclientes",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                success: data => {
                    data.forEach((element, index) => {
                        cliente = {}
                        cliente.code = element.CliCodigo
                        cliente.label = element.CliRazaosocial
                        self.frmDocsTerceiros.clientes.push(cliente)
                    })
                }
            })
        },
        watch: {
            "frmDocsTerceiros.idCliente": function (val) {
                this.getDados();
            },
            "formTipoPessoa.tipoPessoa": function (val) {
                this.getDados();
            }
        },
        computed: {
            isFilevalid: function () {
                const response = {}
                response.status = false
                response.message = 'Por favor selecione um documento'

                if (
                    this.formTipoPessoa.tipoPessoa == 0 &&
                    this.frmDocsPessoais.documento == null
                ) {
                    return response
                }
                if (
                    this.formTipoPessoa.tipoPessoa == 1 &&
                    this.frmDocsTerceiros.documento == null
                ) {
                    return response
                }
                response.status = true
                return response
            },

            isTypeValid: function () {
                const response = {}
                response.status = true
                response.message = 'Por favor selecione o tipo de documento'

                if (
                    this.formTipoPessoa.tipoPessoa == 0 &&
                    this.frmDocsPessoais.tipoDocumento == null
                ) {
                    response.status = false
                    return response
                }
                if (
                    this.formTipoPessoa.tipoPessoa == 1 &&
                    this.frmDocsTerceiros.tipoDocumento == null
                ) {
                    response.status = false
                    return response
                }

                return response
            },

            isTerceiroValid: function () {
                const response = {}
                response.status = false
                response.message = 'Selecione um terceiro'

                if (
                    this.formTipoPessoa.tipoPessoa == 1 &&
                    this.frmDocsTerceiros.idCliente == null
                ) {
                    return response
                }

                response.status = true
                return response
            }
        },
        methods: {
            removeClass: function () {
                if (this.formTipoPessoa.tipoPessoa == 0) {
                    this.frmDocsPessoais.nomeArquivo = ''
                    this.frmDocsPessoais.fileSize = ''
                    document.getElementById('arquivoPessoal').style.display = 'none'
                    document.getElementById('input-file').value = ''
                } else if (this.formTipoPessoa.tipoPessoa == 1) {
                    this.frmDocsTerceiros.nomeArquivo = ''
                    this.frmDocsTerceiros.fileSize = ''
                    document.getElementById('arquivoTerceiro').style.display = 'none'
                    document.getElementById('input-file').value = ''
                }
            },
            rowStyleClassFn(row) {
                if (row.anexo_status == 'Entregue') {
                    return 'greenRow';
                }
                else if (row.anexo_status == 'Em Análise') {
                    return 'yellowRow';
                }
                else if (row.anexo_status == 'Recusado') {
                    return 'redRow';
                }
                else {
                    return 'yellowRow';
                }
            },
            getDados: function () {
                this.registros = [];                
                let pcli_codigo = self.codRevenda;
                if (this.formTipoPessoa.tipoPessoa != 0) {
                    pcli_codigo = this.frmDocsTerceiros.idCliente.code;
                }                
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        let json = JSON.parse(xhr.responseText);
                        json.forEach((element, index) => {
                            let item = {};
                            item.anexo_id = element.ANEXO_ID;
                            item.anexo_nome = element.ANEXO_NOME;
                            item.anexo_data = element.ANEXO_DATA;
                            item.dot_nome = element.DOT_NOME;
                            item.anexo_status = element.ANEXO_STATUS;
                            item.anexo_usuario = element.ANEXO_USUARIO;
                            item.anexo_observacao = element.ANEXO_OBSERVACAO;
                            this.registros.push(item);
                        });
                        this.loadingDocuments = false;
                    }
                }
                xhr.open("POST", this.$apiUrl + "UploadService.svc/getmydocuments");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({                                        
                    cli_codigo:pcli_codigo
                }))
            },
            EnviarPessoais: function (e) {
                // Notifica que submit já foi realizado
                this.frmDocsPessoais.attemptSubmit = true

                // Verifica se os dados são válidos
                if (this.isTypeValid.status && this.isFilevalid.status) {
                    // Caso os dados sejam válidos, realiza a autenticação com o servidor
                    var xhr = new XMLHttpRequest()
                    xhr.onload = () => {
                        if (xhr.status == 201) {
                            swal({
                                title: 'Documento gravado com sucesso',
                                icon: 'success'
                            }).then(() => location.href = `${self.$SiteUrl}/loja/minha-conta`)
                        } else if (xhr.status == 413) {
                            swal({
                                title: 'Arquivo muito grande!',
                                text: 'Tamanho máximo: 2MB',
                                icon: 'warning'
                            })
                        } else {
                            swal({
                                title: 'Erro ao enviar o documento',
                                icon: 'error'
                            })
                        }
                    }

                    xhr.open("POST", this.$apiUrl + "UploadService.svc/uploaddocumento");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(
                        JSON.stringify({
                            nomeArquivo: this.frmDocsPessoais.nomeArquivo,
                            tipoDocumento: this.frmDocsPessoais.tipoDocumento.nome,
                            bytesArquivo: this.frmDocsPessoais.documento,
                            codigoCliente: self.codRevenda,
                            dotcodigo: this.frmDocsPessoais.tipoDocumento.dotcodigo
                        })
                    )

                    // console.log('valido')
                }
            },
            EnviarTerceiros: function (e) {
                // Notifica que submit já foi realizado
                this.frmDocsTerceiros.attemptSubmit = true

                // Verifica se os dados são válidos
                if (
                    this.isTerceiroValid.status &&
                    this.isFilevalid.status &&
                    this.isTypeValid.status
                ) {
                    // Caso os dados sejam válidos, realiza a autenticação com o servidor
                    var xhr = new XMLHttpRequest()
                    xhr.onload = () => {
                        if (xhr.status == 201) {
                            swal({
                                title: 'Documento gravado com sucesso',
                                icon: 'success'
                            })
                        } else if (xhr.status == 413) {
                            swal({
                                title: 'Arquivo muito grande!',
                                text: 'Tamanho máximo: 2MB',
                                icon: 'warning'
                            })
                        } else {
                            swal({
                                title: 'Erro ao enviar o documento',
                                icon: 'error'
                            })
                        }
                    }

                    xhr.open("POST", this.$apiUrl + "UploadService.svc/uploaddocumento");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(
                        JSON.stringify({
                            nomeArquivo: this.frmDocsTerceiros.nomeArquivo,
                            tipoDocumento: this.frmDocsTerceiros.tipoDocumento.nome,
                            bytesArquivo: this.frmDocsTerceiros.documento,
                            codigoCliente: this.frmDocsTerceiros.idCliente.code,
                            dotcodigo: this.frmDocsPessoais.tipoDocumento.dotcodigo
                        })
                    )
                    // console.log('valido')
                }
            },
            SelecionaArquivo: function (ev) {
                var files = ev.target.files || ev.dataTransfer.files
                if (!files.length) return

                let size = parseInt(ev.target.files[0].size / 1000)

                if (this.formTipoPessoa.tipoPessoa == 0) {
                    this.frmDocsPessoais.nomeArquivo = ev.target.files[0].name
                    this.frmDocsPessoais.fileSize =
                        size > 1000
                            ? 'Tamanho: ' + parseInt(size / 1000) + ' MB'
                            : 'Tamanho: ' + size + ' KB'
                } else if (this.formTipoPessoa.tipoPessoa == 1) {
                    this.frmDocsTerceiros.nomeArquivo = ev.target.files[0].name
                    this.frmDocsTerceiros.fileSize =
                        size > 1000
                            ? 'Tamanho: ' + parseInt(size / 1000) + ' MB'
                            : 'Tamanho: ' + size + ' KB'
                }
                //  // console.log(ev);

                const self = this
                let base64 = ''
                const file = ev.target.files[0]
                const reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onloadend = function () {
                    var tipo = $("input[name='TipoDocumento']:checked").val()
                    if (tipo == 0) {
                        base64 = reader.result.replace('data:' + file.type + ';base64,', '')
                        self.frmDocsPessoais.documento = base64
                    } else {
                        base64 = reader.result.replace('data:' + file.type + ';base64,', '')
                        self.frmDocsTerceiros.documento = base64
                    }
                }

                var tipoDoc = $("input[name='TipoDocumento']:checked").val()

                var extPermitidas = ['pdf']
                var extArquivo =
                    tipoDoc == 0
                        ? this.frmDocsPessoais.nomeArquivo
                            .toString()
                            .split('.')
                            .pop()
                        : this.frmDocsTerceiros.nomeArquivo
                            .toString()
                            .split('.')
                            .pop()

                if (
                    typeof extPermitidas.find(function (ext) {
                        return extArquivo == ext
                    }) == 'undefined'
                ) {
                    return false
                } else {
                    return true
                }
            }
        }
    }
</script>
